<!--
 * @Descripttion:
 * @version:
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-04-13 15:46:45
 * @LastEditors: cwl
 * @LastEditTime: 2022-05-11 10:33:55
-->
<template>
  <div class="upload-img">
      <el-upload class="img-list"
      action="http://192.168.10.159:17640/api/upload_webimg"
      list-type="picture-card"
      :file-list='fileList'
      :on-remove="handleRemove"
      :on-preview="handlePictureCardPreview"
      >
      <!-- <div slot="file" slot-scope="{file}" style="width: 100%;height:100%">
        <img
          class="card-img"
          :src="file.url" alt=""
        >
      </div> -->
    </el-upload>
      <el-upload class="upload-list" v-if="fileList.length < 5"
      :action="baseUrl + '/api/upload_webimg'"
      :data='{p:"w"}'
      accept=".png,.jpg,.jpeg,.svg,.apng,.gif"
      name='filePath'
      list-type="picture-card"
      :limit='5'
      :show-file-list="false"
      :file-list='fileList'
      multiple
      :on-success='handleSuccess'
      :on-progress='handleProgress'
      :on-error='handleError'
      :on-exceed='handleExceed'>
      <!-- <i class="el-icon-plus"></i> -->
      <img class="add" src="@/assets/add.png" alt="">
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        fileList: [],
        fileAll: [],
        baseUrl: process.env.VUE_APP_CP_URL
      };
    },
    props:{
      'value': {
        type: Array,
        default: () => {return []}
      }
    },
    methods: {
      // 删除文件
      handleRemove(file, fileList) {
        this.fileList = fileList
        let Idx = this.fileAll.findIndex(t => t === file.response.data.file_path)
        if (Idx>=0) {
          this.fileAll.splice(Idx, 1)
        }
      },
      // 文件预览
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 上传成功后的操作
      handleSuccess (response, file, fileList) {
        if (response.status === 1) {
          file.url =  response.data.file_path_full
          this.fileAll.push(response.data.file_path)
        }
        this.fileList = fileList

      },
      // 上传失败的处理
      handleError(response, file, fileList) {
        this.fileList = fileList
        this.$message({
          message: file.name + '上传失败！',
          type: 'warning'
        });
      },
      // 上传过程中，进度条
      handleProgress (event, file, fileList) {
        this.fileList = fileList
      },
      // 最多上传限制
      handleExceed () {
        this.$message({
          message: '最多上传5张图片',
          type: 'warning'
        });
      }
    },
    watch: {
      fileAll (val) {
        this.$emit('input', val)
      }
    }
  }
</script>
<style lang="scss" scoped>
/deep/ .el-upload--picture-card {
  background: rgba(248,248,248,1);
  border: none;
}
.upload-img {
  display: flex;
}
.card-img {
  display: block;
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}
.add {
  width: 48px;
  height: 48px;
  margin: 0 auto;
  position: relative;
  top: calc(50% - 24px);
}
.img-list {
  // position: absolute;
  flex-shrink: 0;
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
.upload-list {
  // position: absolute;
  top: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/upload-img.vue